import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./DeleteModal.css";
import {
  deleteTractorShipmentById,
  // deleteTractorDailyPlan,
  deleteTractorMonthlyPlan,
} from "../../services/tractorDataService";
import {
  deleteAggregateShipmentById,
  // deleteAggregateDailyPlan,
  deleteAggregateMonthlyPlan,
} from "../../services/aggregateDataService";
import {
  delete5MShipmentById,
  // deleteFiveMDailyPlan,
  deleteFiveMMonthlyPlan,
} from "../../services/fiveMDataService";
import { findIndex, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { dispatcher } from "../../store/storeHelpers";
import {
  TRACTOR_DELETE_SUBROW,
  AGGREGATE_DELETE_SUBROW,
  FIVE_M_DELETE_SUBROW,
  TRANSPORTER_DELETE_ROW,
  ARRIVAL_DELETE_ROW,
  CONTAINER_DELETE_ROW,
  VGM_DELETE_ROW,
  TRACTOR_ETA_DELETE_ROW,
  AGGREGATE_ETA_DELETE_ROW
} from "../../store/ActionTypes";
import moment from "moment";
import {
  getDeleteDataShipmentForTractor,
  getDeleteDataShipmentForAggregate,
  getDeleteDataShipmentFor5M,
  getDeleteMonthlyDataShipment,
} from "../../email-template/planUploadMail";
import { htmlEmailSend } from "../../services/emailService";
import {
  uploadDailyPlanEmailRecepients,
  CC_uploadDailyPlanEmailRecepients,
} from "../../services/emailService";
import {
  // deleteTransporterDataTractor,
  // deleteTransporterDataAggregate,
  // deleteTransporterDataFiveM,
  deleteAllTransporterData,
} from "../../services/TransporterDataService";
import {
  // deleteContainerMasterDataTractor,
  // deleteContainerMasterDataAggregate,
  // deleteContainerMasterDataFiveM,
  deleteAllContainerMasterData,
} from "../../services/ContainerMasterService";
import {
  deleteAllVGMData,
  // deleteVGMDataAggregate,
  // deleteVGMDataFiveM,
  // deleteVGMDataTractor,
} from "../../services/VGMService";
import { filter } from "lodash";
import { getUser } from "../../services/authService";
import { getDailyContainerPlanningAB } from "../../services/tractorDataService";
import * as actionTypes from "../../store/ActionTypes"
import { tractorDataCreatorForStore, aggregateDataCreatorForStore, fiveMDataCreatorForStore } from "../../utils/dataFilter";
import { getAggregateDailyContainerPlanning } from "../../services/aggregateDataService";
import { getFiveMDailyContainerPlanning } from "../../services/fiveMDataService";
import { getCarrierwiseContainerCount } from "../../services/TransporterDataService";
import { formatCarrierwiseContainerCount } from "../../utils/dataFilter";
import { DeleteTractorETAData } from "../../services/tractorEtaDataService";
import { DeleteAggregateETAData } from "../../services/aggregateEtaService";

function DeleteModal({
  show,
  hide,
  dataType,
  tableData,
  showModal,
  label,
  type,
  date,
  selectedMonth,
  monthlyData,
  selectedDeleteRows,
  setNoDataState,
  setCountData,
  ids,
  checkedData,
  setCarrierList
}) {
  const [showDeleteProcess, setShowDeleteProcess] = useState("Yes");
  const [deleteIdState, setDeleteIdState] = useState("");
  const [deleteIdStateAggregate, setDeleteIdStateAggregate] = useState("");
  const [deleteIdStateFiveM, setDeleteIdStateFiveM] = useState("");

  useEffect(() => {
    if (show) {
      if (show.row.originalSubRows) {
        var deleteIdList = "";
        for (let i = 0; i < show.row.originalSubRows.length; i++) {
          if (dataType === "Tractor") {
            if (i !== show.row.originalSubRows.length - 1) {
              deleteIdList +=
                show.row.originalSubRows[i].DailyContainerPlanningId + ",";
            } else {
              deleteIdList +=
                show.row.originalSubRows[i].DailyContainerPlanningId;
            }
          }
          if (dataType === "Aggregate") {
            if (i !== show.row.originalSubRows.length - 1) {
              deleteIdList +=
                show.row.originalSubRows[i].DailyContainerPlanningAggregateId +
                ",";
            } else {
              deleteIdList +=
                show.row.originalSubRows[i].DailyContainerPlanningAggregateId;
            }
          }
          if (dataType === "5M") {
            if (i !== show.row.originalSubRows.length - 1) {
              deleteIdList +=
                show.row.originalSubRows[i].DailyContainerPlanning5MId + ",";
            } else {
              deleteIdList +=
                show.row.originalSubRows[i].DailyContainerPlanning5MId;
            }
          }
        }
        setDeleteIdState(deleteIdList);
      }
    }
    if (selectedDeleteRows) {
      let deleteList = "";
      let deleteListAggregate = "";
      let deleteListFiveM = "";
      const tractorFilterData = filter(selectedDeleteRows, function (o) {
        return o.original.DataOf === "TRACTOR";
      });
      const aggregateFilterData = filter(selectedDeleteRows, function (o) {
        return o.original.DataOf === "AGGREGATE";
      });
      const fiveMFilterData = filter(selectedDeleteRows, function (o) {
        return o.original.DataOf === "5M";
      });
      if (dataType === "Transporter") {
        for (let i = 0; i < tractorFilterData.length; i++) {
          if (tractorFilterData[i].original.DataOf === "TRACTOR") {
            if (i !== tractorFilterData.length - 1) {
              deleteList +=
                tractorFilterData[i].original["TransporterDataId"] + ",";
            } else {
              deleteList += tractorFilterData[i].original["TransporterDataId"];
            }
            setDeleteIdState(deleteList);
          }
        }
        for (let j = 0; j < aggregateFilterData.length; j++) {
          if (aggregateFilterData[j].original.DataOf === "AGGREGATE") {
            if (j !== aggregateFilterData.length - 1) {
              deleteListAggregate +=
                aggregateFilterData[j].original["TransporterDataId"] + ",";
            } else {
              deleteListAggregate +=
                aggregateFilterData[j].original["TransporterDataId"];
            }
            setDeleteIdStateAggregate(deleteListAggregate);
          }
        }
        for (let k = 0; k < fiveMFilterData.length; k++) {
          if (fiveMFilterData[k].original.DataOf === "5M") {
            if (k !== fiveMFilterData.length - 1) {
              deleteListFiveM +=
                fiveMFilterData[k].original["TransporterDataId"] + ",";
            } else {
              deleteListFiveM +=
                fiveMFilterData[k].original["TransporterDataId"];
            }
            setDeleteIdStateFiveM(deleteListFiveM);
          }
        }
      }
      if (dataType === "Arrival Report" || dataType === "Container Master") {
        for (let i = 0; i < tractorFilterData.length; i++) {
          if (tractorFilterData[i].original.DataOf === "TRACTOR") {
            if (i !== tractorFilterData.length - 1) {
              deleteList +=
                tractorFilterData[i].original["ContainerMasterId"] + ",";
            } else {
              deleteList += tractorFilterData[i].original["ContainerMasterId"];
            }
            setDeleteIdState(deleteList);
          }
        }
        for (let j = 0; j < aggregateFilterData.length; j++) {
          if (aggregateFilterData[j].original.DataOf === "AGGREGATE") {
            if (j !== aggregateFilterData.length - 1) {
              deleteListAggregate +=
                aggregateFilterData[j].original["ContainerMasterId"] + ",";
            } else {
              deleteListAggregate +=
                aggregateFilterData[j].original["ContainerMasterId"];
            }
            setDeleteIdStateAggregate(deleteListAggregate);
          }
        }
        for (let k = 0; k < fiveMFilterData.length; k++) {
          if (fiveMFilterData[k].original.DataOf === "5M") {
            if (k !== fiveMFilterData.length - 1) {
              deleteListFiveM +=
                fiveMFilterData[k].original["ContainerMasterId"] + ",";
            } else {
              deleteListFiveM +=
                fiveMFilterData[k].original["ContainerMasterId"];
            }
            setDeleteIdStateFiveM(deleteListFiveM);
          }
        }
      }
      if (dataType === "VGM") {
        for (let i = 0; i < tractorFilterData.length; i++) {
          if (tractorFilterData[i].original.DataOf === "TRACTOR") {
            if (i !== tractorFilterData.length - 1) {
              deleteList +=
                tractorFilterData[i].original["VGMId"] + ",";
            } else {
              deleteList += tractorFilterData[i].original["VGMId"];
            }
            setDeleteIdState(deleteList);
          }
        }
        for (let j = 0; j < aggregateFilterData.length; j++) {
          if (aggregateFilterData[j].original.DataOf === "AGGREGATE") {
            if (j !== aggregateFilterData.length - 1) {
              deleteListAggregate +=
                aggregateFilterData[j].original["VGMId"] + ",";
            } else {
              deleteListAggregate +=
                aggregateFilterData[j].original["VGMId"];
            }
            setDeleteIdStateAggregate(deleteListAggregate);
          }
        }
        for (let k = 0; k < fiveMFilterData.length; k++) {
          if (fiveMFilterData[k].original.DataOf === "5M") {
            if (k !== fiveMFilterData.length - 1) {
              deleteListFiveM +=
                fiveMFilterData[k].original["VGMId"] + ",";
            } else {
              deleteListFiveM +=
                fiveMFilterData[k].original["VGMId"];
            }
            setDeleteIdStateFiveM(deleteListFiveM);
          }
        }
      }
    }
  }, [show, dataType, selectedDeleteRows]);

  
  function yesClickHandler() {
    let counterLabel = []
		let counterValue = {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
		}
    async function deleteShipment() {
      try {
        if (dataType === "Tractor") {
          if (type === "Daily") {
            try {
              setShowDeleteProcess("Deleting...");
              await deleteTractorShipmentById(ids, "Yes");
              if(checkedData !== [])
              {
                await htmlEmailSend(
                  uploadDailyPlanEmailRecepients,
                  CC_uploadDailyPlanEmailRecepients,
                  "Tractor Plan Deleted",
                  getDeleteDataShipmentForTractor(
                    "Tractor",
                    date,
                    checkedData,
                    "Daily"
                  )
                 
                  
                );
              }

              const response = await getDailyContainerPlanningAB(
                moment(date).format("YYYY-MM-DD")
              );
              dispatcher(
                actionTypes.TRACTOR_BOOKING_LOADED,[]
              );
              dispatcher(
                actionTypes.TRACTOR_BOOKING_LOADED,
                tractorDataCreatorForStore(response.data.Resultset1)
              );
              toast.success("Daily Tractor Plan Deleted");
              for (let i = 0; i < response.data.Resultset2.length; i++) {
                counterLabel.push(response.data.Resultset2[i]["STATUS"]);
                if (response.data.Resultset2[i]["STATUS"] === "Booked") {
                  counterValue.Booked =
                    response.data.Resultset2[i]["Container_Count"];
                }
                if (response.data.Resultset2[i]["STATUS"] === "Not_Booked") {
                  counterValue.Not_Booked =
                    response.data.Resultset2[i]["Container_Count"];
                }
                if (response.data.Resultset2[i]["STATUS"] === "Pending") {
                  counterValue.Pending =
                    response.data.Resultset2[i]["Container_Count"];
                }
                if (response.data.Resultset2[i]["STATUS"] === "Approved") {
                  counterValue.Approved =
                    response.data.Resultset2[i]["Container_Count"];
                }
                if (response.data.Resultset2[i]["STATUS"] === "Cancelled") {
                  counterValue.Cancelled =
                    response.data.Resultset2[i]["Container_Count"];
                }
              }
              setCountData({ label: counterLabel, counterData: counterValue });
              hide();
            } catch (error) {
              if (error.response.data.StatusCode === 404) {
                setCountData({
                  label: [],
                  counterData: {
                    Booked: 0,
                    Pending: 0,
                    Approved: 0,
                    Cancelled: 0,
                    Not_Booked: 0,
                  },
                });
                dispatcher(actionTypes.TRACTOR_BOOKING_LOADED, []);
                setNoDataState(true);
                hide();
                setShowDeleteProcess("Yes");
              } else {
                toast.error("something went wrong...please try again.");
                hide();
                setShowDeleteProcess("Yes");
              }
            }
          }
          if (type === "month") {
            try {
              if (!isEmpty(monthlyData)) {
                setShowDeleteProcess("Deleting...");
                await deleteTractorMonthlyPlan(
                  moment(selectedMonth).format("MMM-YY")
                );
                await htmlEmailSend(
                  uploadDailyPlanEmailRecepients,
                  CC_uploadDailyPlanEmailRecepients,
                  "Tractor Monthly Plan Deleted",
                  getDeleteMonthlyDataShipment(
                    "Tractor",
                    selectedMonth,
                    "Monthly"
                  )
                );
                toast.success("Monthly Tractor Plan Deleted");
              } else {
                setShowDeleteProcess("Yes");
                toast.error("Monthly data is not available for this month");
              }
              hide();
            } catch (error) {
              hide();
              setShowDeleteProcess("Yes");
              toast.error("something went wrong...please try again.");
            }
          }
          if (show.row.subRows.length === 0) {
            var tractorDataIndex = findIndex(tableData, {
              Market: show.row.original.Market,
            });
            var updatedTractorData = [];
            setShowDeleteProcess("Deleting...");
            // await deleteTractorShipmentById(
            //   show.row.original.DailyContainerPlanningId
            // );
            for (const item of tableData[tractorDataIndex].subRows) {
              if (
                item.DailyContainerPlanningId !==
                show.row.original.DailyContainerPlanningId
              ) {
                updatedTractorData.push(item);
              }
            }
            var updatedTractorMainRow = [];
            if (updatedTractorData.length === 0) {
              for (const item of tableData) {
                if (item.Market !== show.row.original.Market) {
                  updatedTractorMainRow.push(item);
                }
              }
              // await htmlEmailSend(
              //   uploadDailyPlanEmailRecepients,
              //   CC_uploadDailyPlanEmailRecepients,
              //   "Tractor Plan Deleted",
              //   getDeleteDataShipmentForTractor(
              //     "Tractor",
              //     date,
              //     [show.row.original],
              //     "Daily"
              //   )
              // );
              dispatcher(TRACTOR_DELETE_SUBROW, {
                deleteIdPayload: updatedTractorMainRow,
                statePayload: (data) => {
                  updatedTractorMainRow = data
                },
              });
              if(updatedTractorMainRow.length === 0){
                setNoDataState(true)
              }
            } else {
              tableData[tractorDataIndex].subRows = updatedTractorData;
              dispatcher(TRACTOR_DELETE_SUBROW, {
                deleteIdPayload: tableData,
                statePayload: (data) => {
                  tableData = data
                },
              });
              if(tableData.length === 0){
                setNoDataState(true)
              }
              // await htmlEmailSend(
              //   uploadDailyPlanEmailRecepients,
              //   CC_uploadDailyPlanEmailRecepients,
              //   "Tractor Plan Deleted",
              //   getDeleteDataShipmentForTractor(
              //     "Tractor",
              //     date,
              //     [show.row.original],
              //     "Daily"
              //   )
              // );
            }
            setShowDeleteProcess("Yes");
            hide();
            return toast.success("Tractor data deleted.");
          } else {
            setShowDeleteProcess("Deleting...");
            // await deleteTractorShipmentById(deleteIdState);

            // await htmlEmailSend(
            //   uploadDailyPlanEmailRecepients,
            //   CC_uploadDailyPlanEmailRecepients,
            //   "Tractor Plan Deleted",
            //   getDeleteDataShipmentForTractor(
            //     "Tractor",
            //     date,
            //     show.row.original.subRows,
            //     "Daily"
            //   )
            // );
            var updatedTractorMainRowId = [];
            for (const item of tableData) {
              if (item.Market !== show.row.original.Market) {
                updatedTractorMainRowId.push(item);
              }
            }
            dispatcher(TRACTOR_DELETE_SUBROW, {
              deleteIdPayload: updatedTractorMainRowId,
              statePayload: (data) => {
                updatedTractorMainRowId = data
              },
            });
            if(updatedTractorMainRowId.length === 0){
              setNoDataState(true)
            }
            setShowDeleteProcess("Yes");
            hide();
            return toast.success("Tractor data deleted.");
          }
        }
        if (dataType === "Aggregate") {
          if (type === "Daily") {
            try {
              setShowDeleteProcess("Deleting...");
              await deleteAggregateShipmentById(ids, "Yes");
                await htmlEmailSend(
                  uploadDailyPlanEmailRecepients,
                  CC_uploadDailyPlanEmailRecepients,
                  "Aggregate Plan Deleted",
                  getDeleteDataShipmentForAggregate(
                    "Aggregate",
                    date,
                    checkedData,
                    "Daily"
                  )
                );const response = await getAggregateDailyContainerPlanning(
                  moment(date).format("YYYY-MM-DD")
                );
                dispatcher(
                  actionTypes.AGGREGATE_BOOKING_LOADED,[]
                );
                dispatcher(
                  actionTypes.AGGREGATE_BOOKING_LOADED,
                  aggregateDataCreatorForStore(response.data.Resultset1)
                );
                for (let i = 0; i < response.data.Resultset2.length; i++) {
                  counterLabel.push(response.data.Resultset2[i]["STATUS"])
                  if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                    counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                  }
                  if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                    counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                  }
                  if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                    counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                  }
                  if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                    counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                  }
                  if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                    counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                  }
                }
                setCountData({label : counterLabel, counterData : counterValue})
                toast.success("Daily Aggregate Plan Deleted");
                hide();
            } catch (error) {
              if (error.response.data.StatusCode === 404) {
                setCountData({
                  label: [],
                  counterData: {
                    Booked: 0,
                    Pending: 0,
                    Approved: 0,
                    Cancelled: 0,
                    Not_Booked: 0,
                  },
                });
                dispatcher(actionTypes.AGGREGATE_BOOKING_LOADED, []);
                setNoDataState(true);
                hide();
                setShowDeleteProcess("Yes");
              } else {
                toast.error("something went wrong...please try again.");
                hide();
                setShowDeleteProcess("Yes");
              }
            }
          }
          if (type === "month") {
            try {
              if (!isEmpty(monthlyData)) {
                setShowDeleteProcess("Deleting...");
                await deleteAggregateMonthlyPlan(
                  moment(selectedMonth).format("MMM-YY")
                );
                await htmlEmailSend(
                  uploadDailyPlanEmailRecepients,
                  CC_uploadDailyPlanEmailRecepients,
                  "Aggregate Monthly Plan Deleted",
                  getDeleteMonthlyDataShipment(
                    "Aggregate",
                    selectedMonth,
                    "Monthly"
                  )
                );
                toast.success("Monthly Aggregate Plan Deleted");
              } else {
                setShowDeleteProcess("Yes");
                toast.error("Monthly data is not available for this month");
              }
              hide();
            } catch (error) {
              setShowDeleteProcess("Yes");
              hide();
              toast.error("something went wrong...please try again.");
            }
          }
          if (show.row.subRows.length === 0) {
            var aggregateDataIndex = findIndex(tableData, {
              Country: show.row.original.Country,
            });
            var updatedAggregateData = [];
            setShowDeleteProcess("Deleting...");
            await deleteAggregateShipmentById(
              show.row.original.DailyContainerPlanningAggregateId
            );
            for (const item of tableData[aggregateDataIndex].subRows) {
              if (
                item.DailyContainerPlanningAggregateId !==
                show.row.original.DailyContainerPlanningAggregateId
              ) {
                updatedAggregateData.push(item);
              }
            }
            var updatedAggregateMainRow = [];
            if (updatedAggregateData.length === 0) {
              for (const item of tableData) {
                if (item.Country !== show.row.original.Country) {
                  updatedAggregateMainRow.push(item);
                }
              }
              await htmlEmailSend(
                uploadDailyPlanEmailRecepients,
                CC_uploadDailyPlanEmailRecepients,
                "Aggregate Plan Deleted",
                getDeleteDataShipmentForAggregate(
                  "Aggregate",
                  date,
                  [show.row.original],
                  "Daily"
                )
              );
              dispatcher(AGGREGATE_DELETE_SUBROW, {
                deleteIdPayload: updatedAggregateMainRow,
                statePayload: (data) => {
                  updatedAggregateMainRow = data
                },
              });
              if(updatedAggregateMainRow.length === 0){
                setNoDataState(true)
              }
            } else {
              tableData[aggregateDataIndex].subRows = updatedAggregateData;
              dispatcher(AGGREGATE_DELETE_SUBROW, {
                deleteIdPayload: tableData,
                statePayload: (data) => {
                  tableData = data
                },
              });
              if(tableData.length === 0){
                setNoDataState(true)
              }
              await htmlEmailSend(
                uploadDailyPlanEmailRecepients,
                CC_uploadDailyPlanEmailRecepients,
                "Aggregate Plan Deleted",
                getDeleteDataShipmentForAggregate(
                  "Aggregate",
                  date,
                  [show.row.original],
                  "Daily"
                )
              );
            }
            setShowDeleteProcess("Yes");
            hide();
            return toast.success("Aggregate data deleted.");
          } else {
            setShowDeleteProcess("Deleting...");
            await deleteAggregateShipmentById(deleteIdState);
            await htmlEmailSend(
              uploadDailyPlanEmailRecepients,
              CC_uploadDailyPlanEmailRecepients,
              "Aggregate Plan Deleted",
              getDeleteDataShipmentForAggregate(
                "Aggregate",
                date,
                show.row.original.subRows,
                "Daily"
              )
            );
            var updatedAggregateMainRowId = [];
            for (const item of tableData) {
              if (item.Country !== show.row.original.Country) {
                updatedAggregateMainRowId.push(item);
              }
            }
            dispatcher(AGGREGATE_DELETE_SUBROW, {
              deleteIdPayload: updatedAggregateMainRowId,
              statePayload: (data) => {
                updatedAggregateMainRowId = data
              },
            });
            if(updatedAggregateMainRowId.length === 0){
              setNoDataState(true)
            }
            setShowDeleteProcess("Yes");
            hide();
            return toast.success("Aggregate data deleted.");
          }
        }
        if (dataType === "5M") {
          if (type === "Daily") {
            try {
              setShowDeleteProcess("Deleting...");
              await delete5MShipmentById(ids, "Yes");
              await htmlEmailSend(
                uploadDailyPlanEmailRecepients,
                CC_uploadDailyPlanEmailRecepients,
                "5M Plan Deleted",
                getDeleteDataShipmentFor5M(
                  "5M",
                  date,
                  checkedData,
                  "Daily"
                )
              );
              const response = await getFiveMDailyContainerPlanning(
                moment(date).format("YYYY-MM-DD")
              );
              dispatcher(
                actionTypes.FIVE_M_BOOKING_LOADED,[]
              );
              dispatcher(
                actionTypes.FIVE_M_BOOKING_LOADED,
                fiveMDataCreatorForStore(response.data.Resultset1)
              );
              for (let i = 0; i < response.data.Resultset2.length; i++) {
                counterLabel.push(response.data.Resultset2[i]["STATUS"])
                if(response.data.Resultset2[i]["STATUS"] === "Booked"){
                  counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
                  counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Pending"){
                  counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Approved"){
                  counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
                }
                if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
                  counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
                }
              }
              setCountData({label : counterLabel, counterData : counterValue})
              toast.success("Daily 5M Plan Deleted");
              hide();
            } catch (error) {
              if (error.response.data.StatusCode === 404) {
                setCountData({
                  label: [],
                  counterData: {
                    Booked: 0,
                    Pending: 0,
                    Approved: 0,
                    Cancelled: 0,
                    Not_Booked: 0,
                  },
                });
                dispatcher(actionTypes.FIVE_M_BOOKING_LOADED, []);
                setNoDataState(true);
                hide();
                setShowDeleteProcess("Yes");
              } else {
                toast.error("something went wrong...please try again.");
                hide();
                setShowDeleteProcess("Yes");
              }
            }
          }
          if (type === "month") {
            try {
              if (!isEmpty(monthlyData)) {
                setShowDeleteProcess("Deleting...");
                await deleteFiveMMonthlyPlan(
                  moment(selectedMonth).format("MMM-YY")
                );
                await htmlEmailSend(
                  uploadDailyPlanEmailRecepients,
                  CC_uploadDailyPlanEmailRecepients,
                  "5M Monthly Plan Deleted",
                  getDeleteMonthlyDataShipment("5M", selectedMonth, "Monthly")
                );
                toast.success("Monthly 5M Plan Deleted");
              } else {
                setShowDeleteProcess("Yes");
                toast.error("Monthly data is not available for this month");
              }
              hide();
            } catch (error) {
              setShowDeleteProcess("Yes");
              hide();
              toast.error("something went wrong...please try again.");
            }
          }
          if (show.row.subRows.length === 0) {
            var FiveMDataIndex = findIndex(tableData, {
              Market: show.row.original.Market,
            });
            var updated5MData = [];
            setShowDeleteProcess("Deleting...");
            await delete5MShipmentById(
              show.row.original.DailyContainerPlanning5MId
            );
            for (const item of tableData[FiveMDataIndex].subRows) {
              if (
                item.DailyContainerPlanning5MId !==
                show.row.original.DailyContainerPlanning5MId
              ) {
                updated5MData.push(item);
              }
            }
            var updated5MMainRow = [];
            if (updated5MData.length === 0) {
              for (const item of tableData) {
                if (item.Market !== show.row.original.Market) {
                  updated5MMainRow.push(item);
                }
              }
              await htmlEmailSend(
                uploadDailyPlanEmailRecepients,
                CC_uploadDailyPlanEmailRecepients,
                "5M Plan Deleted",
                getDeleteDataShipmentFor5M(
                  "5M",
                  date,
                  [show.row.original],
                  "Daily"
                )
              );
              dispatcher(FIVE_M_DELETE_SUBROW, {
                deleteIdPayload: updated5MMainRow,
                statePayload: (data) => {
                  updated5MMainRow = data
                },
              });
              if(updated5MMainRow.length === 0){
                setNoDataState(true)
              }
            } else {
              tableData[FiveMDataIndex].subRows = updated5MData;
              dispatcher(FIVE_M_DELETE_SUBROW, {
                deleteIdPayload: tableData,
                statePayload: (data) => {
                  tableData = data
                },
              });
              if(tableData.length === 0){
                setNoDataState(true)
              }
              await htmlEmailSend(
                uploadDailyPlanEmailRecepients,
                CC_uploadDailyPlanEmailRecepients,
                "5M Plan Deleted",
                getDeleteDataShipmentFor5M(
                  "5M",
                  date,
                  [show.row.original],
                  "Daily"
                )
              );
            }
            setShowDeleteProcess("Yes");
            hide();
            return toast.success("5M data deleted.");
          } else {
            setShowDeleteProcess("Deleting...");
            await delete5MShipmentById(deleteIdState);
            await htmlEmailSend(
              uploadDailyPlanEmailRecepients,
              CC_uploadDailyPlanEmailRecepients,
              "5M Plan Deleted",
              getDeleteDataShipmentFor5M(
                "5M",
                date,
                show.row.original.subRows,
                "Daily"
              )
            );
            var updated5MMainRowId = [];
            for (const item of tableData) {
              if (item.Market !== show.row.original.Market) {
                updated5MMainRowId.push(item);
              }
            }
            dispatcher(FIVE_M_DELETE_SUBROW, {
              deleteIdPayload: updated5MMainRowId,
              statePayload: (data) => {
                updated5MMainRowId = data
              },
            });
            if(updated5MMainRowId.length === 0){
              setNoDataState(true)
            }
            setShowDeleteProcess("Yes");
            hide();
            return toast.success("5M data deleted.");
          }
        }
        if (dataType === "Transporter") {
          try {
            const payload = [
              {
                TractorId: deleteIdState,
                AggregateId: deleteIdStateAggregate,
                FiveMId: deleteIdStateFiveM,
                DataAvailable: "Yes",
                Deleted_By: getUser().uid,
              },
            ];
            let finalArray = []
              setShowDeleteProcess("Deleting...");
              await deleteAllTransporterData(payload);
              setShowDeleteProcess("Yes");
            // for (let i = 0; i < selectedDeleteRows.length; i++) {
              // if (selectedDeleteRows[i].original["DataOf"] === "TRACTOR") {
              //   dispatcher(TRANSPORTER_DELETE_ROW, {
              //     deleteIdPayload: deleteIdState.split(","),
              //     statePayload : true
              //     // statePayload: () => setNoDataState(true),
              //   });
              //   setShowDeleteProcess("Yes");
              //   // hide();
              // }
              // if (selectedDeleteRows[i].original["DataOf"] === "AGGREGATE") {
              //   dispatcher(TRANSPORTER_DELETE_ROW, {
              //     deleteIdPayload: deleteIdStateAggregate.split(","),
              //     statePayload: () => setNoDataState(true),
              //   });
              //   setShowDeleteProcess("Yes");
              //   // hide();
              // }
              // if (selectedDeleteRows[i].original["DataOf"] === "5M") {
              //   dispatcher(TRANSPORTER_DELETE_ROW, {
              //     deleteIdPayload: deleteIdStateFiveM.split(","),
              //     statePayload: () => setNoDataState(true),
              //   });
              //   setShowDeleteProcess("Yes");
              //   // hide();
              // }
              if(deleteIdState.length > 0){
                finalArray.push(...deleteIdState.split(","))
              }
              if(deleteIdStateAggregate.length > 0){
                finalArray.push(...deleteIdStateAggregate.split(","))
              }
              if(deleteIdStateFiveM.length > 0){
                finalArray.push(...deleteIdStateFiveM.split(","))
              }
              dispatcher(TRANSPORTER_DELETE_ROW, {
                deleteIdPayload: finalArray,
                statePayload: (data) => {
                  finalArray = data
                },
              });
              if(finalArray.length === 0){
                setNoDataState(true)
              }
              if(deleteIdState || deleteIdStateAggregate || deleteIdStateFiveM){
                hide();
              }
            // }
            toast.success("Transporter data deleted.");
            const response = await getCarrierwiseContainerCount(date);
            setCarrierList(formatCarrierwiseContainerCount(response.data));
          } catch (error) {
            if(error.response.data.StatusCode === 404){
              setCarrierList({})
            }else{
              toast.error(error.response.data.Message);
            }
          }
        }
        if (dataType === "Arrival Report") {
          try {
            const payload = [
              {
                TractorId: deleteIdState,
                AggregateId: deleteIdStateAggregate,
                FiveMId: deleteIdStateFiveM,
                DataAvailable: "Yes",
                Deleted_By: getUser().uid,
              },
            ];
            let finalArray = []
              setShowDeleteProcess("Deleting...");
              await deleteAllContainerMasterData(payload);
              setShowDeleteProcess("Yes");
            // for (let i = 0; i < selectedDeleteRows.length; i++) {
            //   if (selectedDeleteRows[i].original["DataOf"] === "TRACTOR") {
            //     dispatcher(ARRIVAL_DELETE_ROW, {
            //       deleteIdPayload: deleteIdState.split(","),
            //       statePayload: () => setNoDataState(true),
            //     });
            //     setShowDeleteProcess("Yes");
            //     // hide();
            //   }
            //   if (selectedDeleteRows[i].original["DataOf"] === "AGGREGATE") {
            //     dispatcher(ARRIVAL_DELETE_ROW, {
            //       deleteIdPayload: deleteIdStateAggregate.split(","),
            //       statePayload: () => setNoDataState(true),
            //     });
            //     setShowDeleteProcess("Yes");
            //     // hide();
            //   }
            //   if (selectedDeleteRows[i].original["DataOf"] === "5M") {
            //     dispatcher(ARRIVAL_DELETE_ROW, {
            //       deleteIdPayload: deleteIdStateFiveM.split(","),
            //       statePayload: () => setNoDataState(true),
            //     });
            //     setShowDeleteProcess("Yes");
            //     // hide();
            //   }
              if(deleteIdState.length > 0){
                finalArray.push(...deleteIdState.split(","))
              }
              if(deleteIdStateAggregate.length > 0){
                finalArray.push(...deleteIdStateAggregate.split(","))
              }
              if(deleteIdStateFiveM.length > 0){
                finalArray.push(...deleteIdStateFiveM.split(","))
              }
              dispatcher(ARRIVAL_DELETE_ROW, {
                deleteIdPayload: finalArray,
                statePayload: (data) => {
                  finalArray = data
                },
              });
              if(finalArray.length === 0){
                setNoDataState(true)
              }
              if(deleteIdState || deleteIdStateAggregate || deleteIdStateFiveM){
                hide();
              }
            // }
            return toast.success(`Arrival Report data deleted.`);
          } catch (error) {}
        }
        if (dataType === "Container Master") {
          try {
            const payload = [
              {
                TractorId: deleteIdState,
                AggregateId: deleteIdStateAggregate,
                FiveMId: deleteIdStateFiveM,
                DataAvailable: "Yes",
                Deleted_By: getUser().uid,
              },
            ];
            let finalArray = []
              setShowDeleteProcess("Deleting...");
              await deleteAllContainerMasterData(payload);
              setShowDeleteProcess("Yes");

            // for (let i = 0; i < selectedDeleteRows.length; i++) {
            //   if (selectedDeleteRows[i].original["DataOf"] === "TRACTOR") {
            //     dispatcher(CONTAINER_DELETE_ROW, {
            //       deleteIdPayload: deleteIdState.split(","),
            //       statePayload: () => setNoDataState(true),
            //     });
            //     setShowDeleteProcess("Yes");
            //     hide();
            //   }
            //   if (selectedDeleteRows[i].original["DataOf"] === "AGGREGATE") {
            //     dispatcher(CONTAINER_DELETE_ROW, {
            //       deleteIdPayload: deleteIdStateAggregate.split(","),
            //       statePayload: () => setNoDataState(true),
            //     });
            //     setShowDeleteProcess("Yes");
            //     hide();
            //   }
            //   if (selectedDeleteRows[i].original["DataOf"] === "5M") {
            //     dispatcher(CONTAINER_DELETE_ROW, {
            //       deleteIdPayload: deleteIdStateFiveM.split(","),
            //       statePayload: () => setNoDataState(true),
            //     });
            //     setShowDeleteProcess("Yes");
            //     hide();
            //   }
            // }
            if(deleteIdState.length > 0){
              finalArray.push(...deleteIdState.split(","))
            }
            if(deleteIdStateAggregate.length > 0){
              finalArray.push(...deleteIdStateAggregate.split(","))
            }
            if(deleteIdStateFiveM.length > 0){
              finalArray.push(...deleteIdStateFiveM.split(","))
            }
            dispatcher(CONTAINER_DELETE_ROW, {
              deleteIdPayload: finalArray,
              statePayload: (data) => {
                finalArray = data
              },
            });
            if(finalArray.length === 0){
              setNoDataState(true)
            }
            if(deleteIdState || deleteIdStateAggregate || deleteIdStateFiveM){
              hide();
            }
            return toast.success(`Container Master data deleted.`);
          } catch (error) {}
        }
        if (dataType === "VGM") {
          try {
            const payload = [
              {
                TractorId: deleteIdState,
                AggregateId: deleteIdStateAggregate,
                FiveMId: deleteIdStateFiveM,
                DataAvailable: "Yes",
                Deleted_By: getUser().uid,
              },
            ];
            let finalArray = []
            setShowDeleteProcess("Deleting...");
            await deleteAllVGMData(payload);
            setShowDeleteProcess("Yes");
            if(deleteIdState.length > 0){
              finalArray.push(...deleteIdState.split(","))
            }
            if(deleteIdStateAggregate.length > 0){
              finalArray.push(...deleteIdStateAggregate.split(","))
            }
            if(deleteIdStateFiveM.length > 0){
              finalArray.push(...deleteIdStateFiveM.split(","))
            }
            dispatcher(VGM_DELETE_ROW, {
              deleteIdPayload: finalArray,
              statePayload: (data) => {
                finalArray = data
              },
            });
            if(finalArray.length === 0){
              setNoDataState(true)
            }
            if(deleteIdState || deleteIdStateAggregate || deleteIdStateFiveM){
              hide();
            }
            return toast.success("VGM data deleted.");
          } catch (error) {}
        }
        if (type === "TractorETA") {
          try {
            let finalArray = ids.split(",")
            setShowDeleteProcess("Deleting...");
            await DeleteTractorETAData({
              _id: ids,
              _isTractorETAData: "Yes",
            });
            setShowDeleteProcess("Yes");
            dispatcher(TRACTOR_ETA_DELETE_ROW, {
              deleteIdPayload: finalArray,
              statePayload: (data) => {
                finalArray = data
              },
            });
            if(finalArray.length === 0){
              setNoDataState(true)
            }
            hide();
            return toast.success("Tractor ETA data deleted.");
          } catch (error) {}
        }
        if (type === "AggregateETA") {
          try {
            let finalArray = ids.split(",")
            setShowDeleteProcess("Deleting...");
            await DeleteAggregateETAData({
              _id: ids,
              _isAggregateETAData: "Yes",
            });
            setShowDeleteProcess("Yes");
            dispatcher(AGGREGATE_ETA_DELETE_ROW, {
              deleteIdPayload: finalArray,
              statePayload: (data) => {
                finalArray = data
              },
            });
            if(finalArray.length === 0){
              setNoDataState(true)
            }
            hide();
            return toast.success("Aggregate ETA data deleted.");
          } catch (error) {}
        }
      } catch (error) {
        setShowDeleteProcess("Yes");
      }
    }
    deleteShipment();
  }
  return (
    <>
      <Modal
        show={show || showModal.status}
        centered
        className="DeleteModal"
        dialogClassName="deleteWidthClass"
        contentClassName="deleteHeightClass"
      >
        <Modal.Header style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
        <div className="DeleteModal__title">Alert</div>
        </Modal.Header>
        <Modal.Body>
          <div className="DeleteModal__container">
          
         <div className="DeleteModal__description">
                {/* {showModal.msg} */}
                Are you sure you want to delete this record?
            </div>
            <div className="DeleteModal__Btn">
              <Button className="DeleteModal__noBtn" onClick={() => hide()}>
                No
              </Button>
              <Button
                className="DeleteModal__yesBtn"
                onClick={yesClickHandler}
                disabled={showDeleteProcess === "Deleting..."}
              >
                {showDeleteProcess}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default DeleteModal;
